import {lazy, useContext} from 'react'

import UserContext from '../../context/UserContext'

/* istanbul ignore next */
const FactorLibraryPage = lazy(() => import('factorLibrary/factor-library-page'))

export const FactorLibrary = () => {
  const user = useContext(UserContext)

  return <FactorLibraryPage user={user!} />
}
